import { render, staticRenderFns } from "./ApexAreaChart.vue?vue&type=template&id=383e90d3&scoped=true&"
import script from "./ApexAreaChart.vue?vue&type=script&lang=js&"
export * from "./ApexAreaChart.vue?vue&type=script&lang=js&"
import style0 from "./ApexAreaChart.vue?vue&type=style&index=0&id=383e90d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383e90d3",
  null
  
)

export default component.exports